import React from 'react';
import ModalBase, { BaseModalProps } from '../ModalBase/ModalBase';

interface ModalProps {
  children: React.ReactNode;
  baseModalProps: BaseModalProps;
  className?: string;
  overlayClassName?: string;
  contentClassName?: string;
  hideBackButton?: boolean;
  large?: boolean;
  tall?: boolean;
  onRequestClose?: () => void;
  overlayStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  onBack?: () => void;
}

const Modal: React.FC<ModalProps> = ({ children, ...props }) => (
  <ModalBase back_img="Back" {...props}>
    {children}
  </ModalBase>
);

export default Modal;
